import { create } from 'zustand';

type UiStore = {
  selectedElementId: string | null;
  selectedElementIds: string[];
  cropEditingId: string | null;
  zoom: number;
  pan: { x: number; y: number };
  fitRequest: number;
  keepAspectRatio: boolean;
  textWarpEditingId: string | null;
  textEditingId: string | null;
  setSelectedElement: (id: string | null) => void;
  setSelectedElements: (ids: string[], primaryId?: string | null) => void;
  setCropEditing: (id: string | null) => void;
  setZoom: (zoom: number) => void;
  setPan: (x: number, y: number) => void;
  panBy: (deltaX: number, deltaY: number) => void;
  resetView: () => void;
  requestFitView: () => void;
  setKeepAspectRatio: (keep: boolean) => void;
  setTextWarpEditing: (id: string | null) => void;
  setTextEditing: (id: string | null) => void;
};

const MIN_ZOOM = 0.05;
const MAX_ZOOM = 8;

export const useUiStore = create<UiStore>((set) => ({
  selectedElementId: null,
  selectedElementIds: [],
  cropEditingId: null,
  zoom: 1,
  pan: { x: 0, y: 0 },
  fitRequest: 0,
  keepAspectRatio: false,
  textWarpEditingId: null,
  textEditingId: null,
  setSelectedElement: (selectedElementId) => set({ selectedElementId, selectedElementIds: selectedElementId ? [selectedElementId] : [] }),
  setSelectedElements: (selectedElementIds, primaryId = selectedElementIds.at(-1) ?? null) => set({ selectedElementIds, selectedElementId: primaryId }),
  setCropEditing: (cropEditingId) => set({ cropEditingId }),
  setZoom: (zoom) => {
    if (!Number.isFinite(zoom)) return;
    set({ zoom: Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, zoom)) });
  },
  setPan: (x, y) => {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return;
    set({ pan: { x, y } });
  },
  panBy: (deltaX, deltaY) => {
    if (!Number.isFinite(deltaX) || !Number.isFinite(deltaY)) return;
    set((state) => ({ pan: { x: state.pan.x + deltaX, y: state.pan.y + deltaY } }));
  },
  resetView: () => set({ zoom: 1, pan: { x: 0, y: 0 } }),
  requestFitView: () => set((state) => ({ fitRequest: state.fitRequest + 1 })),
  setKeepAspectRatio: (keepAspectRatio) => set({ keepAspectRatio }),
  setTextWarpEditing: (textWarpEditingId) => set({ textWarpEditingId }),
  setTextEditing: (textEditingId) => set({ textEditingId, textWarpEditingId: null }),
}));
